import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import {SOURCE_TYPE} from "../constants/Tpiq.constants";

export function getVendorsDataUrl(org, userId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/vendors`;
}

@Injectable({
  providedIn: 'root'
})
export class VendorsService extends  TaxplanIQServices {

  options = {};
  constructor(http: HttpClient) {
    super(http);
  }

  createOrEditVendor(org, userId, obj): Observable<any> {
    const url = getVendorsDataUrl(org, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getVendorData(org, userId, vendorId): Observable<any> {
    let url = getVendorsDataUrl(org, userId);
    url += `/${vendorId}`;
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  removeVendor(org, userId, vendorId): Observable<any> {
    let url = getVendorsDataUrl(org, userId);
    url += `/${vendorId}`;
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAllVendors(org, userId, fromIndex, searchKey): Observable<any> {
    let url = getVendorsDataUrl(org, userId);
    url += `?fromIndex=${fromIndex}`;
    if (searchKey) {
      url += `&searchString=${searchKey}`;
    }
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): any {
    return throwError(error.error);
  }

}
